export default { sha: '0043b08d531bb82a8553b356b45197d2225a98a0', buildNumber: 'undefined' }
